/* (ignored) */


//////////////////
// WEBPACK FOOTER
// min-document (ignored)
// module id = 2
// module chunks = 1